import { ROUTE_PATH_FAQ, ROUTE_PATH_PRIVACY_POLICY, ROUTE_PATH_TERMS_CONDITIONS, ROUTE_PATH_TERMS_OF_USE } from '../../constants';
import { SiteFooterTranslations } from '../types';

export const translations: SiteFooterTranslations = {
  navMenu: {
    termsOfUse: {
      to: ROUTE_PATH_TERMS_OF_USE,
      exact: true,
      children: 'Conditions d’utilisation du site Web'
    },
    privacyPolicy: {
      to: ROUTE_PATH_PRIVACY_POLICY,
      exact: true,
      children: 'Politique de confidentialité'
    },
    faq: {
      to: ROUTE_PATH_FAQ,
      exact: true,
      children: 'FAQ'
    },
    termsAndConditions: {
      to: ROUTE_PATH_TERMS_CONDITIONS,
      exact: true,
      children: 'Conditions générales d’utilisation'
    }
  }
};
